module.exports = __webpack_public_path__ + "img/promotion7.5cb1078a.png";